import { useId } from "react"
import { colors } from "design"
import { classes } from "utils"
import { typography } from "design"

export const errorLabelVariablesLight = {
  "--resbird-error-label-error": colors.red,
}

export const ErrorLabel = ({ className, error, errorStyle }) => {
  const errorId = useId()
  const id = useId()

  return (
    <label
      className={classes("error-description", className)}
      css={[
        errorStyle,
        {
          marginTop: 5,
          fontSize: 14,
          color: "var(--resbird-error-label-error)",
        },
        typography.widgetLabel
      ]}
      htmlFor={id}
      id={errorId}
      role="aria-errormessage"
    >
      {error}
    </label>
  )
}
